var alignmentStyle = {"alignLeft":"W3004","textWrapNowrap":"_4lAMZ","alignRight":"qla6U","alignCenter":"FUSJH","sizeFullWidth":"vHP3U","renderedInTable":"_8deJ9","sizeOriginal":"biqIB","sizeContent":"xf7B9","sizeSmall":"miScP","sizeSmallCenter":"EpC42","flex":"sKMwy","LEFT":"wKLZa","CENTER":"sgNRF","RIGHT":"_9c9ui","AUTO":"HEiMd","JUSTIFY":"uCsPw"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-de43bc08.js.map
